import React, { createContext } from "react";

const cat = {
  options: [],
  categories: []
};

const catalogueContext = createContext(cat);

export default catalogueContext;
